import { as } from '@utils';

export const getBackendErrors = (error) =>
  Object.fromEntries(
    Object.entries(as.o(error?.errors)).map(([fieldName, errors]) => [
      fieldName,
      Array.isArray(errors) ? errors[0] : null,
    ])
  );
